import React from "react";

type EnergyPerformanceBarProps = {
    selected: any;
    epdLevels: { label: string; color: string }[];
};

const EnergyPerformanceBar: React.FC<EnergyPerformanceBarProps> = ({ selected, epdLevels }) => {
    return (
        <div className={"diagnosis"}>
            {epdLevels.map((level) => (
                <div
                    key={level.label}
                    className="diagnosis-type"
                    style={{
                        height: selected === level.label ? "30px" : "10px",
                        backgroundColor: level.color,
                        borderRadius: selected === level.label ? "8px" : "4px",
                        color: selected === level.label ? "#fff" : "transparent",
                        boxShadow: selected === level.label ? "0 0 5px 2px rgba(0,0,0,0.1)" : "none",
                    }}
                >
                    {level.label}
                </div>
            ))}
        </div>
    );
};

export default EnergyPerformanceBar;